import axios from 'axios';
import authHeader from './auth-header';

const API_URL = 'https://cloud.gmi-aero.com:5000/';

class ConsoleService {
 

  getAllRepairs() {
    return axios.get(API_URL + 'repair/', { withCredentials: true });
  }
  getConsoleRepairs(id) {
   // return axios.get(API_URL + 'repair/'+id, { withCredentials: true });
   
  }
}

export default new ConsoleService();